import React, { Component } from 'react';

export default class TinyEngineContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <p>
                  TinyEngine is a small game engine  which allows users to write games in python, using TinyEngine’s API (written in C++) to handle more complex game systems. It was created by myself and my classmates Tyler Gier and Caroline Pasyanos for our final project in our Building Game Engines course at Northeastern University. Using TinyEngine, users can write their game logic in python and utilize TinyEngine to handle more complex systems like animating sprite sheets and playing sounds.
                </p>

                <p>
                  The engine provides two modules, TinyEngine and TinyMath, for users to create simple games using python. The engine itself is written in C++, and its functions are exported to the python modules using Pybind. This allows users to leverage functionality that C++ provides, including calls to SDL to easily play sounds, render images, and more, in an interpreted language that is easier to use for simple game logics scripts. The goal of this engine is to allow users to write their game logic exclusively in python, and utilizing TinyEngine and TinyMath modules to handle the “heavy lifting” like vector math, rendering sprite sheets, playing music and sound effects, or getting input from the keyboard.
                </p>

              <p>
                Overall, TinyEngine was a blast to develop. While in its current state, it supports enough as an engine to create many different types of games, and we plan to continue development to provide more functionality to the user. Funnily enough, we didn’t realize until about half way through development that all of our demo games are space themed (Space Invaders, Space Race, and Asteroids)! If you would like to try TinyEngine for yourself, or read more about it, visit the team’s write up on TinyEngine’s webpage, or clone the GitHub repository.
              </p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TinyEngineContent.jsx